import {
  TrackingV2CancelOrderInfoQuery,
  TrackingV2CancelOrderInfoQueryVariables
} from '@data/__generated__/types.main'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {useRouter} from 'next/router'

export default function useCancelInfo() {
  const router = useRouter()
  const {orderId} = router.query as {orderId: string}
  const websiteId = useWebsiteId()

  const {website, order} = useApolloQuery<
    TrackingV2CancelOrderInfoQuery,
    TrackingV2CancelOrderInfoQueryVariables
  >({
    query: gql`
      query TrackingV2CancelOrderInfo($websiteId: ID!, $orderId: ID!) {
        website(websiteId: $websiteId) {
          _id
          cancelationCustomMessage
        }
        order(orderId: $orderId) {
          _id
          canUserCancelPendingOrder
        }
      }
    `,
    variables: {
      orderId,
      websiteId
    },
    fetchPolicy: 'cache-first',
    pollInterval: 1000 * 60
  })

  return {
    cancelationCustomMessage: website?.cancelationCustomMessage,
    canUserCancelPendingOrder: order?.canUserCancelPendingOrder
  }
}
